export default {
    apiKey: "AIzaSyAaf6_-Hlxwge-Qg127wHDUm0aHxuSNsI4",
    authDomain: "ihd-official-website.firebaseapp.com",
    databaseURL: "https://ihd-official-website.firebaseio.com",
    storageBucket: "ihd-official-website.appspot.com",
    messagingSenderId: "238468168895"
}



// WEBPACK FOOTER //
// ./src/store/firebase_config.js